import * as React from 'react';
import classNames from 'classnames';
import {Icon} from 'components/UIKit';
import shopGridIcons from './icons';
import localStyle from './shop-display-toggle.scss';

const style = {
  hidden: 'shop-filters__toggle-wrapper--hidden',
  toggle: 'marketing-input-wrapper gutter-bottom--mobile ui-popover__container shop-filters__toggle-wrapper',
};

interface Props {
  tile: boolean;
  hidden: boolean;
  onToggle: () => any;
  className?: string;
}

export default function ShopDisplayToggle({
  tile,
  hidden = false,
  onToggle,
  className,
} : Props) {

  return (
    <label
      className={classNames(className, localStyle.wrap, style.toggle, {
        [style.hidden]: hidden,
      })}
      htmlFor="sort"
    >
      <button
        className="shop-filters__button grid__toggle"
        onClick={onToggle}
        type="button"
      >
        <Icon sourceSVG={tile ? shopGridIcons.list : shopGridIcons.grid} />
      </button>
    </label>
  );
}
